module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "chapter-3"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "x1chap-num"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062015471_Contents#chapter-3"
    }
  }, [_vm._v("Chapter Three")])])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-first-with-overrides"
  }, [_c('span', {
    staticClass: "initial-caps"
  }, [_vm._v("“I")]), _c('span', {
    staticClass: "generated-style-2"
  }, [_vm._v("’ve changed my mind,” Babe said as the plane taxied toward the gate at JFK International.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“What?” Beside her, Wes adjusted his sunglasses and raked his fingers through his thinning, yet highlighted, hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“I can’t do this.” Though she heard from Ellie once in a while and politely hello-ed Amanda on an annual basis, there were reasons why Babe hadn’t returned home in spite of her success at becoming a “star.” Why had she let Wes talk her into it now?")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Wes laughed. “Of course you can do this. It’s all arranged.”")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“This is different. It’s my family. Not a bash in the hills.” The “hills” were the Hollywood Hills, where Babe hadn’t been invited to a single party since she’d turned thirty-five two years ago. She’d thought marrying Wes might have reignited her career, but it turned out he was in worse career shape than she was—his last four films had bombed, and the once-famous six-pack of his abs now drooped from too many decades on earth. At least he’d made up for what he’d lost in appeal by having invested wisely when the going had been good.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“Not to worry, darling,” Wes repeated. He leaned over and kissed her cheek, which, Babe knew, was smoother since she’d secretly snatched eighteen thousand dollars from her husband’s checkbook and had a few well-placed nips and tucks. Thank God, the surgeon was discreet. “I’ve been trying to tell you. Families are more important than you think.”")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("She examined her manicure. An unpleasant tag of skin scuffed her cuticle. “And I’ve been trying to tell you, you don’t know mine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Since notice of the party had arrived (along with instructions to pack a white outfit for a special family photograph Edward wanted snapped), Wes had talked a lot about his estrangement from his two sons. His ex-trophy-wife had moved in with a talk show host who included her on his show every day. The boys now went, too, taking the stage next to the host’s two Paris-Hilton-look-alike daughters.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Today’s ideal blended family")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(", the ratings acclaimed. Ouch.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Babe had never had kids, only an abortion, courtesy of Carleen, who’d been only too glad to arrange it. Even so, Babe sensed her husband’s sorrow. Which, she supposed, was one reason she’d agreed to return to New York.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“Edward is no different from us,” Wes had bellyached. “He once savored the bright lights. He now knows the dark side. Believe me, the man would give anything to have the good stuff back.”")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Babe wasn’t sure about that, but she had decided to let Wes think he and Edward had something in common other than hailing from a similar generation. She’d learned from her previous unions that sometimes it was better to keep your mouth shut and let your man have his own opinion, especially when the topic didn’t really matter.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Choose your battles,")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" her mother had advised one day when fourteen-year-old Babe had asked why Daddy had a mistress in midtown. She had thought that would have been a fair-sized battle in the marital arena, but Mother had shrugged and left Babe in the room, staring at the photo Babe had taken of her father and his lady-friend dining at the Algonquin. Mother had not given the picture a side-glance.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Still, Babe")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chose her battle")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" whenever Wes babbled on like a male jerk. She reminded herself that his blah-blah didn’t matter. What mattered was today and tomorrow. Which was why she’d already talked to her agent about launching a fragrance collection while some fans still remembered her name. Maybe she’d even add a line of signature jewelry. Moving forward made more sense than waiting around until she could be slotted for mature female roles, the kind Sarandon and Streep had made viable and fun. Besides, starting a business made more sense than continuing to peck at Wes’s accounts just because hers were nearly depleted. Needing a man for financial support had never been in Babe’s comfort zone. She’d watched her mother do that for too long.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("The plane curved toward the gate and came to a stop. The seat-belt sign dinged, and Babe let out a sigh. Tugging at the hemline of her skirt, she supposed she shouldn’t have worn spandex. Uncle Edward would dismiss her as too California; Amanda would say thirty-seven was too old to parade that kind of attire; Ellie would smile and keep any critical thoughts to herself. Thank God Carleen wouldn’t be there.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“Smile,” Wes said as he unclicked his seat belt and stood up. “You never know who might be in an airport.”")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("They waited for the attendant to unseal the door, then stepped out of first class as if they still belonged there. They moved up the gangway and into the concourse. That’s when, amid the clutter of gift shops and the reek of fast foods, cameras started flashing and someone boisterously shouted, “Wes! Babe! Wes and Babe! Over here!”")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides-2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh, God")]), _c('span', {
    staticClass: "generated-style-3"
  }, [_vm._v(", Babe thought.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("What’s happening?")]), _c('span', {
    staticClass: "generated-style-3"
  }, [_vm._v(" But because she was a star and knew how to do this, she tossed a wide, automatic smile, glad Wes had paid for a recent whitening.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“See, darling?” Wes said with a naughty wink. “I still have a few friends here and there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("She laughed a sweet-sexy Babe-laugh, then surrendered again to the flash of the cameras, wondering what on earth her husband was up to, and if it was the real reason he had insisted that they come.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-after-txb1-with-overrides"
  }, [_c('span', {
    staticClass: "initial-caps"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "generated-style-2"
  }, [_vm._v("e wasn’t on the island. Ellie and Henry had scoured the perimeter like cable TV reporters stalking the Red Carpet. But there was no sign of the rowboat, not even tucked in an inlet or a wooded hideaway, so there was no point in going ashore.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“Where now?” Henry asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Ellie scanned the lake from the castle at the south end to the hills to the north. The slate-colored water was as calm and flat as a nineteenth-century Hudson River Valley painting—all that was missing was the morning mist, but it was no longer morning, it was after four, and the others would arrive soon.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Damn. Where was Edward?")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("She lowered the paddle into a huddle of lily pads and watched them part as if in a ballet. Edward liked being mischievous, that was true. In his younger years he’d enjoyed a reputation as an imp, a lively producer who, during rehearsals, would switch the prop water with gin just to watch the actor’s reaction, who would hide a whoopee cushion inside a sofa just as the leading lady sat mid-monologue. His antics had not been harmful or hurtful, embarrassing, sometimes, but they’d always elicited laughter and an “Oh, Edward,” with a swat or two to his cheek or his arm or, if he were lucky, a hearty grasp of his backside by a favored star.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("To Ellie’s knowledge, he had never disappeared.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“Maybe he’s back at the house by now,” she said, hoping she sounded optimistic. However, the truth was, Lake Kasteel was fairly large. They might not have seen him if he’d gone overboard; his rickety boat might have sunk. But though Edward had squandered most of his youth as a blue-eyed, roly-poly, quick-witted Irishman, a few years into his relationship with Henry, Henry had goaded him into fitness, beginning with T’ai Chi in a chair. Since then Edward was almost athletic, not knob-kneed like Henry, but fit enough to swim if a need arose.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("So if he’d gone overboard, he still might be safe.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“If we circle the shoreline around the lake, we can check all the docks,” Henry said. “Maybe he tied up the boat and went socializing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("But Ellie knew that Edward had never become friendly with the lake neighbors. Most of them, after all, were only there for the summer. Many of them had, at one time or another, no doubt peered through binoculars at the parties at Edward’s, or rowed their own boats close to his section of shore. Nothing invasive, really. Just for a peek. Edward often said it was more fun to stimulate his neighbors’ imaginations than to invite them over and have them see what bores his friends and he really were.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Haha")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“I can’t imagine whom he would visit,” Ellie said. Then again, she couldn’t imagine why he had left before the party. And why he hadn’t told anyone. Especially her.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“Does he have any old acquaintances around here? A boyfriend, maybe?”")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("He did not mention a")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("girlfriend,")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" though Ellie supposed, like many, that Henry had heard the story long ago of Edward’s heated affair with a woman—the purported")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("true love")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" of his life—whose identity remained a mystery.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("She broke his heart,")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" the gossip had buzzed throughout Times Square,")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("so he turned back to men")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(". Ellie sighed and reminded herself that was ancient, unimportant history. “No, Henry,” she said. “Edward has no old boyfriends around here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“Let’s go back, then,” he said. “Maybe you’re right. Maybe he’s home.”")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-with-overrides"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("She stroked once, twice, three times, turning the canoe. She waited until Henry caught up with her rhythm, then started paddling back toward the house.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-574d8736","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062015471_Chapter_3.vue
// module id = 75
// module chunks = 0